import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent } from '@zeiss/beyond-online-angular';
import { Suggestion } from 'src/app/types/interfaces/order-address-suggestions.interface';
import { PopUpConfig, PopUpRef } from 'vis-ods-angular';

@Component({
	selector: 'app-address-validation',
	templateUrl: './address-validation.component.html',
	imports: [ReactiveFormsModule, ButtonComponent, NgFor, TranslocoModule],
})
export class AddressValidationComponent {
	public addressSelectionForm: UntypedFormGroup;

	constructor(
		private fb: FormBuilder,
		public config: PopUpConfig,
		private popUpRef: PopUpRef,
	) {
		this.addressSelectionForm = this.fb.group({
			selected: [
				this.config.data ? this.config.data.addressSuggestions[0] : null,
				Validators.required,
			],
		});
	}

	isSelected(suggestion: Suggestion): boolean {
		if (this.addressSelectionForm.controls['selected'].value === suggestion) {
			return true;
		} else {
			return false;
		}
	}

	acceptAddressSuggestion(): void {
		this.popUpRef.close(this.addressSelectionForm.controls['selected'].value);
	}

	cancel(): void {
		this.popUpRef.close(null);
	}
}
